// TODO: Evaluate using Node.get(editor, path)

import type { Editor } from 'slate';
import type { SlateBlock, SlateLeaf } from '@atlas/renderer';

export default function getNode<Element extends SlateBlock | SlateLeaf>(
    editor: Editor,
    [index, ...path]: number[],
): Element | undefined {
    let node: SlateBlock | SlateLeaf = editor.children[index];
    if (!node) return;
    while (path.length) {
        if (!('children' in node && node.children[path[0]])) return;

        node = node.children[path[0]];
        path = path.slice(1);
    }
    return node as Element | undefined;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('getNode', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
